module.exports = __webpack_public_path__ + "img/table2.a28e8cae.png";